<template>
  <div>
    <v-dialog
      :value="isQuickbooksDialogOpen"
      width="1000"
      @input="inputQuickbooksDialog"
    >
      <v-card class="rounded-lg">
        <v-card-title class="justify-center">
          <span class="title">
            {{ $t('organization.details.quickbooks.title') }}
          </span>
          <v-btn icon class="close_icon" @click="close">
            <v-icon>
              close
            </v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-6">
          <p
            class="subtitle-2 font-weight-regular grey--text text--darken-1 text-center"
          >
            {{ $t('organization.details.quickbooks.description') }}
          </p>
          <v-row no-gutters>
            <v-col col="12" class="d-flex justify-center align-center">
              <v-text-field
                v-model="localQuickbooksOrganizationName"
                :label="$t('organization.details.quickbooks.label')"
                dense
                outlined
                class="rounded-lg mt-2"
                color="#2661FF"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row no-gutters class="mb-4">
            <v-col cols="12" class="d-flex justify-end align-center">
              <v-btn
                color="#2661FF"
                class="rounded-lg mr-2"
                :loading="isLoading"
                @click="save"
              >
                <span class="white--text">
                  {{ $t('actions.save') }}
                </span>
                <v-icon class="ml-1" color="white">
                  upload
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
  name: 'ObservationDialog',
  data() {
    return {
      localQuickbooksOrganizationName: null,
      isLoading: false
    }
  },
  created() {
    this.localQuickbooksOrganizationName = this.organization.quickbooks_name
  },
  computed: {
    ...mapState({
      organization: ({ organization: { organization } }) => organization,
      isQuickbooksDialogOpen: ({ organization: { isQuickbooksDialogOpen } }) =>
        isQuickbooksDialogOpen
    })
  },
  methods: {
    ...mapActions({
      updateOrganization: 'organization/updateOrganization'
    }),
    ...mapMutations({
      toggleQuickbooksDialog: 'organization/toggleQuickbooksDialog'
    }),
    inputQuickbooksDialog(arg) {
      if (!arg) {
        this.close()
      }
    },
    close() {
      this.toggleQuickbooksDialog(false)
    },
    async save() {
      this.isLoading = true

      const payload = {
        id: this.organization.id,
        body: {
          quickbooks_name: this.localQuickbooksOrganizationName
        }
      }

      await this.updateOrganization(payload)

      this.close()

      this.isLoading = false
    }
  }
}
</script>
<style>
.custom_card {
  border-radius: 12px !important;
  border: 1px solid #d0d3db !important;
}

.close_icon {
  position: absolute;
  top: 14px;
  right: 15px;
}
</style>
